// 更新密码

<template>
  <Card title="修改密码">
    <template slot="content">
      <div class="chane_input">
        <MInput
          v-model="newPassword"
          placeholder="新密码，不修改请无视"
          icon="icon-shurumima"
        ></MInput>
      </div>
      <div class="submit-btn">
        <MButton
          class="btn"
          :disabled="canISubmit"
          @click="changePwd"
          :loading="loading"
          >确认</MButton
        >
      </div>
    </template>
  </Card>
</template>

<script>
import Card from "@/components/common/Card";
import MInput from "@/components/common/Input";
import MButton from "@/components/common/Button";
import { upUserPwd } from "@/api/user";
export default {
  components: {
    Card,
    MButton,
    MInput,
  },
  data() {
    return {
      newPassword: "",
      loading: false,
    };
  },
  methods: {
    changePwd() {
      this.$utils.throttle(() => {
        this.loading = true;
        upUserPwd({ password: this.newPassword }).then(
          (res) => {
            this.loading = false;
            this.show = true;
            this.newPassword = "";
            this.$tip.success("更新密码成功");
          },
          (err) => {
            this.loading = false;
            this.$tip.danger("更新失败");
          }
        );
      }, 10000);
    },
  },
  computed: {
    canISubmit: function () {
      return this.newPassword == "";
    },
  },
};
</script>

<style lang="less" scoped>
.btn {
  background: #5932ea;
  color: #fff;
}
</style>
